import { render, staticRenderFns } from "./LegacyUnifiedSearch.vue?vue&type=template&id=4cdce41c&scoped=true"
import script from "./LegacyUnifiedSearch.vue?vue&type=script&lang=js"
export * from "./LegacyUnifiedSearch.vue?vue&type=script&lang=js"
import style0 from "./LegacyUnifiedSearch.vue?vue&type=style&index=0&id=4cdce41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdce41c",
  null
  
)

export default component.exports